import React from 'react';
import { Megaphone, Mail, ChevronDown, ChevronUp, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';

export const OrderCallHistory = ({ history, expandedCall, onToggleExpand, onDelete }) => {
    if (history.length === 0) return null;

    return (
        <Card className="rounded-2xl shadow-sm">
            <CardHeader>
                <CardTitle className="text-lg">Historique des appels</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
                {history.map(call => (
                    <div key={call.id} className="border rounded-xl p-4 hover:bg-gray-50/50 transition-colors">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center">
                                    <Megaphone className="w-4 h-4 text-amber-600" />
                                </div>
                                <div>
                                    <p className="font-medium text-sm">
                                        {call.products?.length || 0} produits — {call.clients_count || 0} clients
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        Deadline: {call.deadline} | Envoyé le {new Date(call.created_at).toLocaleDateString('fr-FR')}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                {call.emails_sent > 0 && (
                                    <Badge className="bg-blue-50 text-blue-700 rounded-lg text-xs">
                                        <Mail className="w-3 h-3 mr-1" />{call.emails_sent}
                                    </Badge>
                                )}
                                <Button variant="ghost" size="sm" onClick={() => onToggleExpand(call.id)} className="h-7 px-2">
                                    {expandedCall === call.id ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
                                </Button>
                                <Button variant="ghost" size="sm" onClick={() => onDelete(call.id)} className="h-7 px-2 text-red-500 hover:bg-red-50">
                                    <Trash2 className="w-3.5 h-3.5" />
                                </Button>
                            </div>
                        </div>
                        {expandedCall === call.id && (
                            <div className="mt-3 pt-3 border-t space-y-2 text-sm">
                                {call.message && <p className="text-gray-600 italic">"{call.message}"</p>}
                                <div className="flex flex-wrap gap-1">
                                    {call.products?.map(p => (
                                        <Badge key={p.id} variant="outline" className="text-xs rounded-lg">
                                            {p.name} {p.price ? `${p.price.toFixed(2)}€` : ''}
                                        </Badge>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};
